import {
  CardBody,
  CardButtonWrapper,
  CardInformative,
  CardListActions,
  CardSupport,
  ListItemModifier,
  TagLayout,
  TagWrapper
} from './style';
import { InformativeTag, Label, List, ListItem, MainButton } from '@icarros/ids-react';
import { LISTING, OFFERS, PERFORMANCE } from '../../../../../utils/routes';
import {
  formatFabricationAndModelYear,
  formatPriceToReal,
  removePlural
} from '../../../../utils/formatters';

import { CardOptions } from './CardOptions';
import { CardProps } from './constants';
import React from 'react';
import { getFirstImage } from '../../../../utils/getFirstImage';
import { pushSellerPFDashboardEvent } from '../../../../../utils/pushToDataLayer';
import { useHistory } from 'react-router-dom';
import { useRenewAd } from '../../../../hooks/useRenewAd';
import { useWebappFlags } from '../../../../hooks/useWebAppFlags';

export function Expired({ card }: Readonly<CardProps>): JSX.Element {
  const { renewMutation } = useRenewAd(card.id);
  const history = useHistory();
  const { getFlagOnSession } = useWebappFlags();

  return (
    <>
      <div>
        <img src={getFirstImage(card.fotos)} alt="Primeira imagem do anuncio" />
      </div>
      <CardBody>
        <CardSupport>
          <CardInformative>
            {card.filterText && (
              <InformativeTag variant="outlined" type="error">
                {removePlural(card.filterText)}
              </InformativeTag>
            )}
          </CardInformative>
          <CardOptions editId={card.id} showDelete showHelp showEdit />
        </CardSupport>
        <List>
          <ListItemModifier>
            <ListItem
              label={`${card.veiculo.marca.nome} ${card.veiculo.modelo.nome}`}
              subLabel={`${card.veiculo.versao.nome} ${formatFabricationAndModelYear(
                card.veiculo.anoFabricacao,
                card.veiculo.anoModelo
              )}`}
              variant="action"
              actionOnClick={() => {
                pushSellerPFDashboardEvent('>');
                history.push(`${LISTING}/${card.id}`);
              }}
            />
          </ListItemModifier>
        </List>
        <TagLayout>
          <Label size="medium" variant="neutral" weight="bold">
            {formatPriceToReal(card.valorVenda)}
          </Label>
          {card.chassiVerificado?.status && getFlagOnSession('validacaoChassi') && (
            <TagWrapper>
              <InformativeTag type="success" variant="outlined">
                Placa e chassi verificados
              </InformativeTag>
            </TagWrapper>
          )}
        </TagLayout>
        <CardListActions>
          <List>
            <ListItem
              avatarIcon="itaufonts_mercado_noticias"
              avatarVariant="icon"
              label="acessar performance"
              variant="action"
              actionOnClick={() => {
                pushSellerPFDashboardEvent('acessar performance');
                history.push(`${LISTING}/${card.id}${PERFORMANCE}`);
              }}
            />
            <ListItem
              avatarIcon="itaufonts_sms_mensagem_chat"
              avatarVariant="icon"
              label="acessar mensagens"
              variant="action"
              actionOnClick={() => {
                pushSellerPFDashboardEvent('acessar mensagens');
                history.push(`${OFFERS}/${card.id}`);
              }}
            />
          </List>
          <CardButtonWrapper>
            <MainButton
              text="Editar"
              variant="primary"
              iconName="itaufonts_seta_right"
              onClick={() => {
                pushSellerPFDashboardEvent('editar anúncio');
                history.push(`${LISTING}/${card.id}`);
              }}
            />

            {card.podeRenovar && (
              <MainButton
                text="Renovar"
                iconName="itaufonts_seta_right"
                onClick={() => {
                  pushSellerPFDashboardEvent('Renovar');
                  renewMutation.mutate();
                }}
                isLoading={renewMutation.isLoading}
              />
            )}
          </CardButtonWrapper>
        </CardListActions>
      </CardBody>
    </>
  );
}
